import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import {
  IconWithText,
  Icon,
  Tabs,
  WarningMessageModal,
  MobileStrip,
  MobileItemList,
} from 'Components';
import history from 'src/history';
import './TemplatesMobile.css';

const TemplatesMobile = (props) => {
  const isGlobalSearch = Object.keys(props.globalSearch).length > 0;
  const translatedTabs = props.tabs.map((tab) => i18n.t(`templates:${tab}`));

  const mobileKeys = {
    fixedkeys: (props.data.keys || []).slice(0, 4),
    bodyKeys: [
      'ProjectNumber',
      'SiteLocation',
      'POAFENumber',
      'SiteNumber',
      'CreatedByName',
      'CreatedDate',
    ],
    uniqueKey: 'Id',
    code: 'template',
  };
  const [section, setSectionName] = useState('');
  const [isWarningMessageOpen, setOpenWarningMessage] = useState(false);

  const handleProceed = () => {
    history.push('/templates/new');
    setOpenWarningMessage(false);
  };
  const handleCancle = () => {
    setOpenWarningMessage(false);
  };
  const handlOnClick = () => {
    if (props.isTemplateWarningON === 'ON') {
      setSectionName('Template');
      setOpenWarningMessage(true);
    } else {
      history.push('/templates/new');
    }
  };

  return (
    <div className="templates-mobile">
      <MobileStrip
        title={i18n.t('head:eCOC Templates')}
        left="/"
        right="/jobs"
      />
      {isGlobalSearch ? (
        <div className="templates-mobile__clear-search">
          <Link to="/templates">
            <Icon icon="close" />
            <span>{i18n.t('common:Clear Search')}</span>
          </Link>
        </div>
      ) : (
        <div className="templates-mobile__new">
          <IconWithText
            className="templates-mobile__new-template"
            onClick={handlOnClick}
            icon="add_circle"
            text={i18n.t('head:New Template')}
            textOrientation="before"
          />
        </div>
      )}

      <div className="templates-mobile__tabs">
        {!isGlobalSearch && (
          <Tabs
            className="tabs__button"
            tabs={translatedTabs}
            index={props.data.tabIndex}
            onClick={props.onTabsChange}
          />
        )}
        <MobileItemList
          hasPinned
          mobileKeys={mobileKeys}
          setPageState={props.setPageState}
          data={props.data}
          powerTableIndex={props.powerTableIndex}
          onOptionClick={props.onOptionClick}
          onPinClick={props.onPinClick}
          userName={props.userName}
          keyPairs={props.data.keyPairs}
          noInforTitleText={i18n.t('templates:NoTemplates')}
          noInfoSubText={i18n.t('templates:NewTemplate1')}
          noInfoLinkText={i18n.t('templates:NewTemplate2')}
          noInfoLink="/templates/new"
          isSupplyWarningON={props.isSupplyWarningON}
          isTemplateWarningON={props.isTemplateWarningON}
          isSubmissionWarningON={props.isSubmissionWarningON}
          isPrepaid={props.isPrepaid}
        />
      </div>
      <div>
        {isWarningMessageOpen && (
          <WarningMessageModal
            onProceed={handleProceed}
            onCancel={handleCancle}
            section={section}
          />
        )}
      </div>
    </div>
  );
};

TemplatesMobile.propTypes = {
  globalSearch: PropTypes.shape({}),
  userName: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.string),
  onOptionClick: PropTypes.func,
  onPinClick: PropTypes.func,
  tabIndex: PropTypes.number,
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    data: PropTypes.arrayOf(PropTypes.string),
    keys: PropTypes.arrayOf(PropTypes.string),
    keyPairs: PropTypes.shape({}),
    tabIndex: PropTypes.number,
  }),
  powerTableIndex: PropTypes.number,
  setPageState: PropTypes.func,
  onTabsChange: PropTypes.func,
  isTemplateWarningON: PropTypes.bool,
  isSupplyWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  isPrepaid: PropTypes.bool,
};

export default TemplatesMobile;



// WEBPACK FOOTER //
// ./src/containers/Templates/TemplatesMobile/TemplatesMobile.jsx